import * as React from "react";
import { graphql } from "gatsby";
import Layout from "@qlik/qlik/src/components/Layout";
import RichText from "@qlik/qlik/src/components/RichText";

/**
 * NotFoundPage component
 * This component is displayed when a user tries to access a non-existent page.
 * @returns {JSX.Element} - The rendered NotFoundPage component
 */

export const query = graphql`
    query {
        contentfulHeader: contentfulHeader(name: { eq: "Header" }) {
            ...Header
        }
        contentfulFooter(name: { eq: "Full footer" }) {
            ...Footer
        }
        contentfulThemeSettings {
            id
            name
            socialSharingPlatforms
            pageNotFoundData {
                raw
            }
        }
    }
`;

const NotFoundPage = ({ data }) => {
    const richTextContent = { body: data.contentfulThemeSettings?.pageNotFoundData };
    return (
        <Layout headerData={data.contentfulHeader} footerData={data.contentfulFooter}>
            <section className="container text-center mt-[156px] mb-12.5 m xl:my-[178px] xl:mb-25">
                <RichText data={richTextContent} className="page-not-found" />
            </section>
        </Layout>
    );
};

export default NotFoundPage;
